import React from 'react';
import { components } from 'react-select';

const Input = props => {
  if (props.isHidden) {
    return <components.Input {...props} />;
  }
  return <components.Input {...props} autoComplete="new-password" />;
};

export default Input;
